import clsx from 'clsx'
import styles from './Loader.module.scss'

export const Loader = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['loading']}>
        <div className={clsx(styles['square'], styles['square--1'])}></div>
        <div className={clsx(styles['square'], styles['square--2'])}></div>
        <div className={clsx(styles['square'], styles['square--3'])}></div>
        <div className={clsx(styles['square'], styles['square--4'])}></div>
        <div className={clsx(styles['square'], styles['square--5'])}></div>
      </div>
    </div>
  )
}
